import { render, staticRenderFns } from "./ScrollUp.vue?vue&type=template&id=250d9b56"
import script from "./ScrollUp.vue?vue&type=script&lang=js"
export * from "./ScrollUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports